import { z } from 'zod'

import { PaginationParamsSchema, PaginationSchema } from '@/schemas/pagination'

const CompanySchema = z.object({
  cod_empresa: z.number(),
  razao_social: z.string(),
  documento: z.string(),
})

type Company = z.infer<typeof CompanySchema>

const CompaniesSchema = z
  .object({
    data: z.array(CompanySchema),
  })
  .merge(PaginationSchema)

type Companies = z.infer<typeof CompaniesSchema>

const CompaniesParamsSchema = z.object({}).merge(PaginationParamsSchema)

type CompaniesParams = z.infer<typeof CompaniesParamsSchema>

const UpdateCurrentCompanyParamsSchema = z.object({
  id: z.number(),
})

type UpdateCurrentCompanyParams = z.infer<
  typeof UpdateCurrentCompanyParamsSchema
>

export {
  CompanySchema,
  CompaniesSchema,
  CompaniesParamsSchema,
  UpdateCurrentCompanyParamsSchema,
  type Company,
  type Companies,
  type CompaniesParams,
  type UpdateCurrentCompanyParams,
}
